import React, { useState, useEffect } from 'react'
import SelectWrapper from './select_wrapper'
import timeZones from '../data/us_state_county_time_zones.json' // Import the JSON file statically

// Define the type for the timeZones JSON structure
interface CountyZone {
    County: string
    'Climate Zone': string
    'warm-humid?': string
}
interface TimeZoneData {
    [state: string]: CountyZone[]
}

interface USStateSelectWrapperProps {
    label: React.ReactNode
    path: string
    required?: boolean
}

const USStateSelectWrapper: React.FC<USStateSelectWrapperProps> = ({
    label,
    path,
    required,
}) => {
    const [states, setStates] = useState<string[]>([])

    useEffect(() => {
        // Extract state codes from the keys of the JSON file
        const stateCodes: string[] = Object.keys(timeZones as TimeZoneData)
        setStates(stateCodes)
    }, [])

    return (
        <SelectWrapper
            options={states}
            label={label}
            path={path}
            required={required}
        />
    )
}

export default USStateSelectWrapper
